{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.hopfgarten.softline",
  "name": "Softline"
}
